import React, { Component } from 'react';

export default class FilaDepartamento extends Component {
  constructor(props) {
    super(props);
    
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e) {
    let departamentoId = this.props.deptoId;

    if (this.props.vendido !== 'Vendido') {
        this.props.onclick(departamentoId);
    }
  }

  render() {
    let theClass = this.props.vendido === 'Vendido' ? 'sold' : 'available';
    return (
      <td className={ theClass } onClick={ this.clickHandler }>
        { this.props.numero }
      </td>
    );
  }
}


// WEBPACK FOOTER //
// ./react_src/Components/FilaDepartamento.js